import $ from 'jquery';
import imask from 'imask';

const inputPatternCheck = (input, message, pattern) => {
    const match = input.val().trim().match(pattern);
    if (match === null) {
        input[0].setCustomValidity(message);
    } else {
        input[0].setCustomValidity('');
    }
};

$('input').each(function () {
    const input = $(this);
    const pattern = input.attr('data-validate-pattern');
    if (pattern !== undefined) {
        let message = input.attr('data-validate-title');
        message = message || 'Введённые данные неверны';

        input.change(() => inputPatternCheck(input, message, pattern));
        input.keyup(() => inputPatternCheck(input, message, pattern));
    }
});

const inputPhoneCheck = (input, message) => {
    const value = input.val().replace(/[^0-9.]/g, '');
    // если preCheck = 789 - значит пользователь начал писать 8 913 и тд
    const preCheck = value.toString().substr(0, 3);
    if (value.length !== 11 || preCheck === '789') {
        input[0].setCustomValidity(message);
    } else {
        input[0].setCustomValidity('');
    }
};

const setCaretPosition = (ctrl, pos) => {
    // Modern browsers
    if (ctrl.setSelectionRange) {
        ctrl.focus();
        ctrl.setSelectionRange(pos, pos);

        // IE8 and below
    } else if (ctrl.createTextRange) {
        var range = ctrl.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
    }
}

$('.control-input--phone, .input-phone').each(function () {
    const input = $(this);
    let message = input.attr('data-validate-title');
    message = message || 'Проверьте, что номер телефона заполнен правильно';

    imask(input[0], {
        mask: '+7 (000)-000-00-00',
        lazy: false,
        overwrite: true,
        autofix: true,
        blocks: {
            ___: { mask: '000', placeholderChar: '___' },
            __: { mask: '00', placeholderChar: '__' }
        }
    });

    if (input.val() === '+7 (___)-___-__-__') {
        input.val('');
    }

    input.focus(() => {
        if (input.val() === '') {
            input.keydown();
            input.val('+7 (___)-___-__-__');
            setCaretPosition(input[0], 4);
        }
    });

    input.blur(() => {
        if (input.val() === '+7 (___)-___-__-__') {
            input.val('');
        }
    });

    input.change(() => inputPhoneCheck(input, message));
    input.keyup(() => inputPhoneCheck(input, message));
});
